import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: 10,
    border: '1px solid #D9D9D9',
  },
  text: {
    marginTop: 16,
    textAlign: 'center',
  },
  button: {
    marginTop: 24,
    lineHeight: '18px',
    height: 40,
  },
}));

export default useStyles;
